export const loadedConfigStore = { current: {} }
